import { StyleSystemProps } from '@withjoy/joykit';

export const dialogStyles = {
  headerContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: 6,
  } as StyleSystemProps,

  title: {
    marginY: 5,
    textAlign: 'center',
  } as StyleSystemProps,

  warningText: {
    color: 'mono12',
    textAlign: 'center',
  } as StyleSystemProps,

  paymentAccountContainer: {
    flexDirection: 'column',
    marginBottom: 5,
    alignItems: 'center',
    paddingY: 6,
    backgroundColor: 'mono1',
    borderRadius: '12px',
    borderColor: 'mono3',
    borderWidth: '1px',
    borderStyle: 'solid',
  } as StyleSystemProps,

  paymentAccountLabel: {
    color: 'mono14',
    textAlign: 'center',
    marginBottom: 5,
  } as StyleSystemProps,

  paymentUsernameContainer: {
    alignItems: 'center',
    marginBottom: 5,
  } as StyleSystemProps,

  paymentUsername: {
    color: 'linkText',
    textAlign: 'center',
  } as StyleSystemProps,

  testPaymentButton: {
    paddingX: 4,
    height: 'fit-content',
  } as StyleSystemProps,

  testPaymentButtonIcon: {
    marginLeft: 2,
  } as StyleSystemProps,

  testWarningText: {
    marginBottom: 5,
    color: 'mono12',
  } as StyleSystemProps,

  accordionContainer: {
    marginBottom: 6,
    _before: {
      content: '""',
      width: '100%',
      height: '1px',
      backgroundColor: 'mono3',
      display: 'block',
    },
    _after: {
      content: '""',
      width: '100%',
      height: '1px',
      backgroundColor: 'mono3',
      display: 'block',
    },
  } as StyleSystemProps,

  accordionItem: {
    _notLastChild: {
      _after: {
        content: '""',
        width: '100%',
        height: '1px',
        backgroundColor: 'mono3',
        display: 'block',
      },
    },
  } as StyleSystemProps,

  accordionButton: {
    paddingY: 6,
    width: '100%',
    borderRadius: '0',
  } as StyleSystemProps,

  accordionButtonContent: {
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  } as StyleSystemProps,

  accordionButtonTitle: {
    color: 'mono12',
  } as StyleSystemProps,

  accordionButtonIcon: {
    color: 'mono14',
  } as StyleSystemProps,

  accordionPanel: {
    paddingTop: 3,
    paddingBottom: 6,
  } as StyleSystemProps,

  accordionPanelContent: {
    color: 'mono12',
    whiteSpace: 'pre-line',
  } as StyleSystemProps,

  accordionPanelLinkContainer: {
    flexDirection: 'column',
    gap: 3,
  } as StyleSystemProps,

  accordionPanelLink: {
    color: 'mono12',
    textDecorationColor: 'mono12',
    _visited: {
      color: 'mono12',
      textDecorationColor: 'mono12',
    },
  } as StyleSystemProps,

  accordionPanelLinkText: {
    color: 'mono12',
  } as StyleSystemProps,

  agreementContainer: {
    flexDirection: 'column',
    gap: 3,
    marginBottom: 6,
  } as StyleSystemProps,

  agreementInstruction: {
    color: 'mono12',
  } as StyleSystemProps,

  agreementInput: {
    width: '100%',
  } as StyleSystemProps,

  errorText: {
    marginTop: 1,
  } as StyleSystemProps,

  checkboxesContainer: {
    flexDirection: 'column',
    gap: 4,
    marginBottom: 6,
  } as StyleSystemProps,

  checkboxOverrides: {
    Root: {
      props: {
        alignItems: 'flex-start',
      },
    },
    Label: {
      props: {
        alignItems: 'flex-start',
        paddingTop: 0,
      },
    },
  },

  actionButtonsContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 5,
  } as StyleSystemProps,
};
